module.exports = __webpack_public_path__ + "img/BE0713574857.8ab3f80b.png";